
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/credit-transfer",
      function () {
        return require("private-next-pages/dashboard/credit-transfer/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/credit-transfer"])
      });
    }
  